export default __webpack_public_path__ + "static/media/office.4c80f50f.svg";